export default __webpack_public_path__ + "60209c449fbb5df30c8bb9ed3e68560b.png";